/** True when public API calls target same-origin BFF (empty or relative api.url). */
export function isSameOriginPublicApi(endpoint: string): boolean {
  return !endpoint || endpoint.startsWith("/") || !/^https?:\/\//i.test(endpoint);
}
